import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MobileDetectorService } from "src/app/core/services/mobile-detector.service";
import { MobilePageMapperService } from "src/app/core/services/mobile-page-mapper.service";

@Injectable({
  providedIn: 'root'
})
export class RedirectToMobilePageGuard  {
  private readonly router = inject(Router);
  private readonly mobileDetectorService = inject(MobileDetectorService);
  private readonly mobilePageMapperService = inject(MobilePageMapperService);

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.mobileDetectorService.isMobile()) {
      // A redirect returned as a UrlTree keeps the navigation's own `replaceUrl` (and replaces
      // the URL for one the browser started - typed in, Back/Forward). The imperative navigate()
      // this used to do pushed a new entry, so e.g. /not-found reached with replaceUrl still
      // stacked /mobile/not-found on top of the shipment URL (LBRD-6418).
      const mobilePath = this.mobilePageMapperService.get(state.url) ?? '/mobile';
      return this.router.createUrlTree([mobilePath], { queryParams: next.queryParams });
    }

    return true;
  }
}
